import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { AdminDashboard } from '../components/admin';

function Home() {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8">
            Welcome to Orgadoro Admin
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
            Please log in to access the admin dashboard.
          </p>
        </div>
      </div>
    );
  }

  return <AdminDashboard />;
}

export default Home;
